import { useSearchParams } from 'react-router-dom'
import { ExactScopeName, useHasScope } from '~hooks/permissions/use-has-scope'
import {
  getFeatureToggle,
  nonProductionFeaturesEnabled,
} from '~utils/feature-toggles'

export function useOperationsSubpages() {
  const [searchParams] = useSearchParams()
  const isMtUser = useHasScope(ExactScopeName.maerskTankersUser)
  const hasIncidentsAccess = useHasScope(ExactScopeName.incidentsWriter)
  const hasDryDockAccess = useHasScope(ExactScopeName.dryDockWriter)
  const hasVesselProfileAccess = useHasScope(ExactScopeName.vesselProfileWriter)

  if (isMtUser === undefined) {
    // loading state
    return []
  }

  if (!isMtUser) {
    return [
      { link: `/operations/rejections?${searchParams}`, title: 'Rejections' },
      { link: `/operations/sire?${searchParams}`, title: 'SIRE' },
      { link: `/operations/cdi?${searchParams}`, title: 'CDI' },
    ]
  }

  return [
    ...(hasIncidentsAccess
      ? [{ link: `/operations/incidents?${searchParams}`, title: 'Incidents' }]
      : []),
    { link: `/operations/rejections?${searchParams}`, title: 'Rejections' },
    { link: `/operations/sire?${searchParams}`, title: 'SIRE' },
    { link: `/operations/cdi?${searchParams}`, title: 'CDI' },
    { link: `/operations/vesseldata?${searchParams}`, title: 'Vessel Data' },
    ...(hasDryDockAccess
      ? [{ link: `/operations/dry-dock?${searchParams}`, title: 'Dry Dock' }]
      : []),
    ...(hasVesselProfileAccess
      ? [
          {
            link: `/operations/vessel-profile?${searchParams}`,
            title: 'Vessel Profile',
          },
        ]
      : []),
    { link: `/operations/recap-hub?${searchParams}`, title: 'Recap Hub' },
    ...(getFeatureToggle(nonProductionFeaturesEnabled)
      ? [
          {
            link: `/operations/hull-operations?${searchParams}`,
            title: 'Hull Operations',
          },
        ]
      : []),
  ]
}
